import React, {Component} from 'react';
import Axios from "axios";
import AppUrl from "../AppUrl/ApiUrl";
import {toast} from "react-toastify";
import Menu from "../components/Menu";
import Loading from "../components/Loading";

class TransferEdit extends Component {
    constructor({match}) {
        super();
        this.state={
            token:"",coin_symbol:"",from_address:"",to_address:"",amount:"",status:"",email:"",
            id:match.params.id,fee_coin_name:"",fee_amount:"",trx:"",uid:"",created_at:"",type:"",verify:"",
            loading:true,loading1:false,price:"0",bal:"0",
            fee: "0" // সেটিংসের ফি রাখার জন্য স্টেট
        }
    }

    async componentDidMount() {
        var token = localStorage.getItem("admintoken")
        this.setState({token:token})

        // সেটিংস থেকে ডায়নামিক ফি ফেচ করা
        this.fetchSettings();

        const form = new FormData()
        form.append("id",this.state.id)
        form.append("token",token)
        await Axios.post(AppUrl.baseurl+"onepay",form)
            .then(res=>{
                console.log(res.data)
                if (res.data.error) {
                    this.setState({loading: false})
                } else {
                    var val = res.data.data[0]
                    this.setState({coin_symbol:val["coin_symbol"],username:val["username"],
                        created_at:val["created_at"],loading:false,
                        from_address:val["fromid"],to_address:val["toid"],
                        amount:val["amount"],fee_coin_name:val["fee_coin_name"],
                        status:val["status"],trx:val["trx"],
                        uid:val["uid"],fee_amount:val["fee_amount"],
                        type:val["type"],price:val["price"]
                    })
                    var price = parseFloat(val["price"])
                    var amount = parseFloat(val["amount"])
                    var aa = 1/price
                    var bal = aa*amount
                    this.setState({bal:bal})
                }

            })
            .catch(err=>{
                console.log(err)
            })
    }

    // অ্যাপ সেটিংস ফেচ করার ফাংশন
    fetchSettings = async () => {
        try {
            let res = await Axios.get(AppUrl.baseurl + "get-settings");
            if (res.data && res.data.success && res.data.data) {
                console.log(res.data.data.fee)
                this.setState({
                    fee: res.data.data.fee
                });
            }
        } catch (err) {
            console.log("Settings fetch error:", err);
        }
    };

    trx=(e)=>{
        this.setState({trx:e.target.value})
    }
    from_address=(e)=>{
        this.setState({from_address:e.target.value})
    }

    status=(e)=>{
        this.setState({status:e.target.value})
    }

    onsubmitForm=async (event)=>{
        event.preventDefault()
        var fda = new FormData()
        fda.append("token",this.state.token)
        fda.append("id",this.state.id)
        fda.append("status",this.state.status)
        fda.append("trx",this.state.trx)
        fda.append("fromid",this.state.from_address)
        this.setState({loading1:true})
        await Axios.post(AppUrl.baseurl+"transfer/confirm",fda)
            .then(res => {
                if(res.data.success){
                    this.componentDidMount()
                    toast.success(res.data.success, {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                    setTimeout(()=>{
                        this.props.history.push("/transfer")
                    },1000)
                }else{
                    toast.error(res.data.error, {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                }
                this.setState({loading1:false})
            })
            .catch(err => {
                console.log(err)
                this.setState({loading1:false})
            })
    }

    render() {
        // যদি ডাটাবেজের ডাইরেক্ট ফি অ্যামাউন্ট না থাকে, তবে সেটিংস থেকে প্রাপ্ত ফি ফিল্ড হিসেবে দেখাবে
        var displayFee = this.state.fee_amount && parseFloat(this.state.fee_amount) > 0
            ? this.state.fee_amount
            : this.state.fee;

        return (
            <Menu title="Edit and View ">
                <h3 className="bg-white title-head"> View Or Edit </h3>
                <div className="container-fluid currency-add">
                    <div className="row">
                        <div className="col-md-11">
                            {
                                this.state.loading===true ? <Loading/> :
                                    <form className="mt-2" onSubmit={this.onsubmitForm}>
                                        <div className="row">
                                            <div className="col-md-6">
                                                <label>User ID</label>
                                                <input type="text" readOnly value={this.state.uid} className="form-control shadow-none" />
                                            </div>

                                            <div className="col-md-6">
                                                <label>Date</label>
                                                <input type="text" readOnly value={this.state.created_at} className="form-control shadow-none" />
                                            </div>
                                            <div className="col-md-6">
                                                <label>Payment Type</label>
                                                <input type="text" readOnly value={this.state.type} className="form-control shadow-none" />
                                            </div>
                                            <div className="col-md-6">
                                                <label>Status</label>
                                                <select id="inputState" required onChange={this.status} value={this.state.status} className="form-control shadow-none">
                                                    <option value="Pending">Pending</option>
                                                    <option value="Success">Success</option>
                                                    <option value="Rejected">Rejected</option>
                                                </select>
                                            </div>
                                            <div className="col-md-6">
                                                <label>Amount</label>
                                                <input type="text" readOnly value={this.state.amount+" "+this.state.coin_symbol} className="form-control shadow-none" />
                                            </div>
                                            <div className="col-md-6">
                                                <label>Withdrew Fee</label>
                                                <input type="text" readOnly value={this.state.fee + " USD"} required className="form-control shadow-none" />
                                            </div>
                                            <div className="col-md-6">
                                                <label>To Address</label>
                                                <input type="text" readOnly value={this.state.to_address} required className="form-control shadow-none" />
                                            </div>
                                            <div className="col-md-6">
                                                <label>From Address</label>
                                                <input type="text" onChange={this.from_address} value={this.state.from_address} className="form-control shadow-none" />
                                            </div>
                                            <div className="col-md-12">
                                                <label>Trx ID</label>
                                                <input type="text" onChange={this.trx} value={this.state.trx} className="form-control shadow-none" />
                                            </div>

                                            <p className="mt-5">
                                                {this.state.amount} {this.state.coin_symbol}
                                            </p>

                                            <div className="col-md-12 mt-4 mb-5">
                                                <button disabled={this.state.loading1} onClick={this.onsubmitForm} type="submit" style={{width:"150px"}}
                                                        className="btn btn-primary shadow-none">{this.state.loading1===true?"Loading...":"Update Payment Status"}
                                                </button>
                                            </div>
                                        </div>
                                    </form>
                            }
                        </div>
                    </div>
                </div>
            </Menu>
        );
    }
}

export default TransferEdit;